const navData = [
    {
      id: 0,
      src: '../../../img/rent-item-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'rent item icon',
      text: "Rent Item",
      flex: "49%",
      href: '/rent'
    },
    {
      id: 1,
      src: '../../../img/lend-item-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'lend item icon',
      text: "Lend Item",
      flex: "49%",
      href: '/add'
      //this will need a link per design files
    },
    {
      id: 2,
      src: '../../../img/inbox-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'inbox icon',
      text: "Inbox",
      flex: "49%",
      href: '#'
    },
    {
      id: 3,
      src: '../../../img/profile-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'profile icon',
      text: "Profile",
      flex: "49%",
      href: '/item'
    },
    {
      id: 4,
      src: '../../../img/explore-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'explore icon',
      text: "My Items",
      flex: "49%",
      href: '/myitems'
    },
    {
      id: 5,
      src: '../../../img/customer-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'customer service icon',
      text: "Customer Service",
      flex: "49%",
      href: '/contact'
    }
  ];
  
  const homeData = [
    {
      id: 0,
      src: '../../../img/tv-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'tv icon',
      text: "TV & Home Theater",
      flex: "30%",
      href: '/tv'
    },
    {
      id: 1,
      src: '../../../img/computer-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'computer icon',
      text: "Desktops & Laptops",
      flex: "30%",
      href: '/computer'
    },
    {
      id: 2,
      src: '../../../img/camera-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'camera icon',
      text: "Cameras & Videocameras",
      flex: "30%",
      href: '/camera'
    },
    {
      id: 3,
      src: '../../../img/fridge-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'fridge icon',
      text: "Appliances",
      flex: "30%",
      href: '/appliance'
    },
    {
      id: 4,
      src: '../../../img/music-note-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'music note icon',
      text: "Audio",
      flex: "30%",
      href: '/audio'
    },
    {
      id: 5,
      src: '../../../img/gadgets-icon.png',
      //src: 'https://via.placeholder.com/125',
      alt: 'gadgets icon',
      text: "Gadgets",
      flex: "30%",
      href: '/gadget'
    }
  ];

  const footerHome = [
    {
      id: 0,
      src: '../../../img/profile-icon.png',
      alt: 'Profile icon',
      text: "Create Profile",
      flex: "30%",
      href: '/registration'
      //will need a real link
    },
    {
      id: 1,
      src: '../../../img/answer-questions-icon.png',
      alt: 'answer questions icon',
      text: "Answer Questions",
      flex: "30%",
      href: '#'
    },
    {
      id: 2,
      src: '../../../img/list-item-icon.png',
      alt: 'list item icon',
      text: "List Item",
      flex: "30%",
      href: '/add'
      //will need a real link
    }
  ];

  const middleHome = [
    {
      id: 0,
      src: '../../../img/bluetooth-speaker.png',
      alt: 'list item icon',
      title: "Bluetooth party speakers",
      price: "$52/night",
      ratingSrc: 'https://via.placeholder.com/25',
      flex: "28%",
      href: '/item'
      //will need a real link
    },
    {
      id: 0,
      src: '../../../img/monitor.png',
      alt: 'list item icon',
      title: "Desktop monitor/screen",
      price: "$38/night",
      ratingSrc: 'https://via.placeholder.com/25',
      flex: "28%",
      href: '#'
    },
    {
      id: 2,
      src: '../../../img/Waterproof-camera.png',
      alt: 'list item icon',
      title: "Waterproof camera",
      price: "$86/night",
      ratingSrc: 'https://via.placeholder.com/25',
      flex: "28%",
      href: '#'
    }
  ];

  export { navData, homeData, footerHome, middleHome }
  